import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  Package,
  BarChart3,
  ArrowRightLeft,
  FileSpreadsheet,
  CheckSquare,
} from "lucide-react";

import { WarehouseDashboard } from "./dashboard/WarehouseDashboard";
import { WarehouseList } from "./master-data/WarehouseList";
import { WarehouseLocationTab } from "./master-data/WarehouseLocationTab";
import InventoryNXTPage from "./inventory/InventoryNXTPage";
import { MapPin } from "lucide-react";

export function WarehouseModule() {
  const [activeTab, setActiveTab] = useState("dashboard");

  return (
    <div className="w-full px-4 sm:px-6 py-4 space-y-4">
      <Tabs
        value={activeTab}
        onValueChange={setActiveTab}
        className="space-y-4"
      >
        {/* Điện thoại: tabs cuộn ngang, không ép 4 cột làm chữ dính nhau */}
        <div className="overflow-x-auto hide-scrollbar">
        <TabsList>
          <TabsTrigger value="dashboard" className="flex items-center gap-2 shrink-0 whitespace-nowrap">
            <BarChart3 className="w-4 h-4" /> Tổng quan
          </TabsTrigger>
          <TabsTrigger value="master" className="flex items-center gap-2 shrink-0 whitespace-nowrap">
            <Package className="w-4 h-4" /> Danh mục Kho
          </TabsTrigger>
          <TabsTrigger value="locations" className="flex items-center gap-2 shrink-0 whitespace-nowrap">
            <MapPin className="w-4 h-4" /> Vị trí Kệ Kho
          </TabsTrigger>
          <TabsTrigger value="nxt" className="flex items-center gap-2 shrink-0 whitespace-nowrap">
            <FileSpreadsheet className="w-4 h-4" /> Báo cáo NXT
          </TabsTrigger>
        </TabsList>
        </div>

        <TabsContent value="dashboard">
          <WarehouseDashboard />
        </TabsContent>

        <TabsContent value="master">
          <WarehouseList />
        </TabsContent>

        <TabsContent value="locations">
          <WarehouseLocationTab />
        </TabsContent>

        <TabsContent value="nxt">
          <InventoryNXTPage />
        </TabsContent>

      </Tabs>
    </div>
  );
}
